export interface CreateBulkUpdateCollectionListRequest {
  collectionIds: number[]
}

export function CreateBulkUpdateCollectionListRequestToJSON(
  value: CreateBulkUpdateCollectionListRequest
): any {
  return {
    collection_ids:
      value.collectionIds.length > 0 ? value.collectionIds : undefined
  }
}
